<template>
  <div class="container" :style="{ background: style.background }">
    <div class="content">
      <Header />
       <router-view></router-view>
      <Footer />
    </div>
  </div>
  <transition name="fade" mode="out-in">
    <view class="loading" v-if="loading" :style="{ background: style.background }">
      <img :src="loadingStyle.icon" :style="loadingStyle.style" />
    </view>
  </transition>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      style: window.globalConfig.defaultStyle,
      loading: true,
      loadingStyle: window.globalConfig.loadingStyle,
    };
  },
  created() {
    document.title = this.style.h5title
    document.getElementById('html-root').style.backgroundColor = window.globalConfig.defaultStyle.sideBackground;
  },
  mounted() {
    localStorage.setItem('newsDetailTop', 0)
    setTimeout(() => {
      this.loading = false;
    }, 500);
    this.style?.onLoad?.();
  },
};
</script>

<style>
body {
  padding-bottom: 130px;
  width: 750px;
  margin: auto;
}

* {
  padding: 0;
  margin: 0;
}
.loading {
  position: fixed;
  z-index: 999999;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.container {
  /* min-height: 100vh; */
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
